import { GacClient } from '@is24at/react-utils';
import { universalFetch } from 'core/fetch';
import { ANBIETER_API_PREFIX } from 'utils/enums';

export default new GacClient({
  fetch: universalFetch,
  prefix: ANBIETER_API_PREFIX,
});
